export const PROVIDER_DOCUMENT_TYPE_IDS = {
  malpractice: 1,
  professional: 2,
  driver: 3,
  contract: 4,
} as const;

export const REQUIRED_PROVIDER_DOCUMENT_TYPE_IDS: number[] = [
  PROVIDER_DOCUMENT_TYPE_IDS.driver,
  PROVIDER_DOCUMENT_TYPE_IDS.professional,
  PROVIDER_DOCUMENT_TYPE_IDS.malpractice,
];

export const PROVIDER_UPLOAD_DOCUMENT_TYPE_IDS: number[] = [
  ...REQUIRED_PROVIDER_DOCUMENT_TYPE_IDS,
  PROVIDER_DOCUMENT_TYPE_IDS.contract,
];

export const PROVIDER_DOCUMENT_TYPE_LABELS: Record<number, string> = {
  [PROVIDER_DOCUMENT_TYPE_IDS.malpractice]: 'Malpractice Insurance',
  [PROVIDER_DOCUMENT_TYPE_IDS.professional]: 'Professional License',
  [PROVIDER_DOCUMENT_TYPE_IDS.driver]: "Driver's License",
  [PROVIDER_DOCUMENT_TYPE_IDS.contract]: 'Contract',
};

export function isProviderUploadDocumentTypeId(value: unknown): boolean {
  return PROVIDER_UPLOAD_DOCUMENT_TYPE_IDS.includes(Number(value));
}
